import React from 'react';
import { severityTone } from '../lib/executiveCommandCenterFormatters';

const StrategicRecommendationsPanel = ({ items }) => {
  const rows = Array.isArray(items) ? items : [];

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Strategic Recommendations</h3>
      <div className="mt-3 grid gap-3 md:grid-cols-2">
        {rows.map((rec) => (
          <article key={rec.id} className={`rounded-xl border p-3 ${severityTone(rec.severity)}`}>
            <div className="mb-2 flex items-center justify-between gap-2">
              <span className="text-[11px] font-semibold uppercase tracking-wide">{rec.category}</span>
              <span className="text-[11px] font-semibold uppercase tracking-wide">{rec.severity}</span>
            </div>
            <h4 className="text-sm font-semibold">{rec.title}</h4>
            <p className="mt-1 text-xs opacity-90">{rec.message}</p>
            <div className="mt-2 rounded-md border border-current/25 bg-black/10 p-2 text-xs">
              <span className="font-semibold">Recommended Action:</span> {rec.recommendedAction}
            </div>
          </article>
        ))}
        {rows.length === 0 ? <div className="text-sm text-slate-500">Belum ada rekomendasi strategis.</div> : null}
      </div>
    </section>
  );
};

export default StrategicRecommendationsPanel;
